import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth-routes/admin/pnlStructures')({
  beforeLoad: () => {
    throw redirect({ to: '/admin/pnlStructure' })
  },
})
